import '@fontsource/space-grotesk/latin.css'
import '@fontsource/space-mono/latin.css'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import '@mantine/notifications/styles.css'
import '@mantine/dropzone/styles.css'
import 'mantine-react-table/styles.css'

import { setupSentry } from '@opsopti/shared'
import * as Sentry from '@sentry/react'
import ReactDOM from 'react-dom/client'

import App, { FallBackApp } from '@/App'

import { version } from './package.json'

setupSentry({ version })

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={props => <FallBackApp {...props} />}>
    <App />
  </Sentry.ErrorBoundary>,
)
